import { render, staticRenderFns } from "./ZhaoshangData.vue?vue&type=template&id=531dc1e8&scoped=true"
import script from "./ZhaoshangData.vue?vue&type=script&lang=js"
export * from "./ZhaoshangData.vue?vue&type=script&lang=js"
import style0 from "./ZhaoshangData.vue?vue&type=style&index=0&id=531dc1e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531dc1e8",
  null
  
)

export default component.exports